import {BOT_CONV_MESSAGE_TYPE} from '../../../../helpers/consts/common-consts';
import './text-message.css';
import dayjs from 'dayjs';
import ReactMarkdown from "react-markdown";

// relative time https://day.js.org/docs/en/plugin/relative-time
export default function TextMessage({senderType, message, chatBotSetting}) {
  let theme;
  let styleBg;
  let styleText;

  if (senderType === BOT_CONV_MESSAGE_TYPE) {
      theme = 'conv-text-message-bot';
      styleBg = {};
      styleText = {};
  } else {
      theme = 'conv-text-message-user';
      styleBg = {background: chatBotSetting.headerBackgroundColor};
      styleText = {color: chatBotSetting.headerTextColor}
  }

  // Convert plain URLs/emails to markdown links so ReactMarkdown renders them as anchors
  const autoLink = (text) => {
    if (!text || typeof text !== 'string') return '';
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)|(mailto:[^\s]+)|([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return text.replace(urlRegex, (match) => {
      let href = match;
      // Email: add mailto: if plain email
      if (emailRegex.test(href)) {
        href = `mailto:${href}`;
      } else {
        // Add scheme for www. links (but not for mailto:)
        if (!/^https?:\/\//i.test(href) && !/^mailto:/i.test(href)) {
          href = `https://${href}`;
        }
      }
      return `[${match}](${href})`;
    });
  };

  const enhancedMessage = autoLink(message);

  return (
    <ReactMarkdown 
    className="prose text-gray-700 md:text-base text-sm bg-gray-100 rounded-md p-4"
    components={{
      a: ({node, ...props}) => (
        <a
          {...props}
          target="_blank"
          rel="noopener noreferrer"
        />
      ),
    }}
    >
      {enhancedMessage}
    </ReactMarkdown>
  );
}

